<template>
  <div>
    <jt-data-table
      v-if="invoices && fields"
      :apiMode="false"
      :singleselect="false"
      :nonselect="true"
      :isPaginated="false"
      :fields="fields"
      :data="invoices"
      noneselect
      rowKey="boundResidue"
      :columnEdit="paintCell"
      >
      <template #body="{ props }">
        <q-tr class="text-left">
          <q-td v-for="col in props.cols" :key="col.name" :props="props" style="color: #333">
            <div v-if="col.field == 'year'">
              <span style="font-size: 14px">
                {{ getInvoiceMonthOrReference(props.row) }}
              </span>
              <br />
              <span style="font-size: 14px">
                {{ props.row['year'] }}
              </span>
            </div>
            <div v-else-if="isValueLocaleBr(col.field)">
              {{ $toLocaleStringBr(props.row[col.field]) }}
            </div>
            <span v-else-if="col.field == 'situation'">
              <invoice-situation
                v-if="isDefault(props.row.due, props.row.situation)"
                :text="getSituatinByKey(props.row.situation).text"
                :color="getSituatinByKey(props.row.situation).color" />
              <invoice-situation
                  v-else
                  :text="getSituatinByKey('Vencida').text"
                  :color="getSituatinByKey('Vencida').color"
                />
              <span> {{ $gettext('IN') + '' + getFormattedDue(props.row['due'])}} </span>
            </span>
          </q-td>
        </q-tr>
      </template>
    </jt-data-table>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable } from 'jtech-webcomps'
import InvoiceSituation from '../component/InvoiceSituation.vue'
import { situationMap } from '../../invoice/component/situation.config'
import moment from 'moment'
import { getInvoiceMonthOrReference } from 'src/shared/global/UtilInvoice'

@Component({
  name: 'ServiceRequestInvoiceSettlementDatatable',
  components: {
    JtDataTable,
    InvoiceSituation
  },
  props: {
    fields: [],
    invoices: []
  }
})

class ServiceRequestInvoiceSettlementDatatable extends Vue {
  moment = moment;
  getInvoiceMonthOrReference = getInvoiceMonthOrReference;

  isValueLocaleBr (field) {
    const localeFields = ['value', 'writeOff', 'nominalValue', 'debt', 'valuePayment', 'restitution']
    return localeFields.includes(field)
  }

  get situationMap () {
    return situationMap
  }

  getFormattedDue (due) {
    return moment(due, 'YYYY-MM-DD HH:mm:ss.mm').format('DD/MM/YYYY')
  }

  getSituatinByKey (key) {
    if (key) {
      for (const situation in this.situationMap) {
        if (
          Object.prototype.hasOwnProperty.call(this.situationMap, situation)
        ) {
          const situationKeys = this.situationMap[situation].keys || []
          if (situationKeys.includes(key.toString())) {
            return this.situationMap[situation]
          }
        }
      }
    }
    return { text: key, color: '#fff' }
  }

  isDueExpired (due, situation) {
    if (!due) return false
    return moment(due, 'YYYY-MM-DD HH:mm:ss.S').isBefore(moment()) && situation != 50130007
  }

  isDefault (due, situation) {
    return !this.isDueExpired(due, situation) || situation == 50130005
  }
}

export default ServiceRequestInvoiceSettlementDatatable
</script>
